<template>
  <div class="major-manage">
    <el-card>
      <div slot="header" class="card-header">
        <span class="title">专业信息管理</span>
        <div>
          <el-input 
            v-model="searchKeyword" 
            placeholder="搜索专业或院校" 
            style="width: 250px; margin-right: 10px"
            clearable
            @clear="loadData"
          >
            <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
          </el-input>
          <el-button type="primary" icon="el-icon-plus" @click="handleAdd">添加专业</el-button>
        </div>
      </div>
      
      <el-table :data="tableData" style="width: 100%" border stripe>
        <el-table-column prop="categoryType" label="大类编码" width="120"/>
        <el-table-column prop="categoryName" label="专业类别" width="200"/>
        <el-table-column prop="collegeName" label="院校名称" width="200"/>
        <el-table-column prop="majorName" label="专业名称" width="180"/>
        <el-table-column prop="planCount" label="计划数" width="100" align="center"/>
        <el-table-column prop="tuitionFee" label="学费(元/年)" width="120" align="center"/>
        <el-table-column label="操作" width="200" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button size="small" type="primary" icon="el-icon-edit" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button size="small" type="danger" icon="el-icon-delete" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px">
        <el-form :model="form" :rules="rules" ref="form" label-width="120px">
          <el-form-item label="大类" prop="categoryType">
            <el-select v-model="form.categoryType" placeholder="请选择大类" style="width: 100%">
              <el-option 
                v-for="item in categoryList" 
                :key="item.id" 
                :label="`${item.categoryType} - ${item.categoryName}`" 
                :value="item.categoryType">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="专业类别" prop="categoryName">
            <el-input v-model="form.categoryName" placeholder="如：酒店管理与数字化运营"/>
          </el-form-item>
          <el-form-item label="院校名称" prop="collegeName">
            <el-input v-model="form.collegeName" placeholder="如：南京晓庄学院"/>
          </el-form-item>
          <el-form-item label="专业名称" prop="majorName">
            <el-input v-model="form.majorName" placeholder="如：秘书学"/>
          </el-form-item>
          <el-form-item label="计划数" prop="planCount">
            <el-input-number v-model="form.planCount" :min="0" style="width: 100%"/>
          </el-form-item>
          <el-form-item label="学费(元/年)" prop="tuitionFee">
            <el-input-number v-model="form.tuitionFee" :min="0" style="width: 100%"/>
          </el-form-item>
        </el-form>
        <span slot="footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleSubmit">确定</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import majorApi from '../api/major'
import categoryApi from '../api/category'

export default {
  name: 'MajorManage',
  data() {
    return {
      tableData: [],
      categoryList: [],
      searchKeyword: '',
      dialogVisible: false,
      dialogTitle: '添加专业',
      form: {
        categoryType: '',
        categoryName: '',
        collegeName: '',
        majorName: '',
        planCount: 0,
        tuitionFee: 0
      },
      rules: {
        categoryType: [
          { required: true, message: '请选择大类', trigger: 'change' }
        ],
        categoryName: [
          { required: true, message: '请输入专业类别', trigger: 'blur' }
        ],
        collegeName: [
          { required: true, message: '请输入院校名称', trigger: 'blur' }
        ],
        majorName: [
          { required: true, message: '请输入专业名称', trigger: 'blur' }
        ],
        planCount: [
          { required: true, message: '请输入计划数', trigger: 'blur' }
        ],
        tuitionFee: [
          { required: true, message: '请输入学费', trigger: 'blur' }
        ]
      },
      isEdit: false
    }
  },
  mounted() {
    this.loadData()
    this.loadCategories()
  },
  methods: {
    async loadData() {
      try {
        const res = await majorApi.getList()
        if (res.data.code === 200) {
          this.tableData = res.data.data
        }
      } catch (error) {
        this.$message.error('加载数据失败')
      }
    },
    async loadCategories() {
      try {
        const res = await categoryApi.getList()
        if (res.data.code === 200) {
          this.categoryList = res.data.data
        }
      } catch (error) {
        this.$message.error('加载大类数据失败')
      }
    },
    async handleSearch() {
      if (!this.searchKeyword.trim()) {
        this.loadData()
        return
      }
      // 这里可以调用搜索接口，暂时使用前端过滤
      const res = await majorApi.getList()
      if (res.data.code === 200) {
        this.tableData = res.data.data.filter(item => 
          item.majorName.includes(this.searchKeyword) || 
          item.collegeName.includes(this.searchKeyword) ||
          item.categoryName.includes(this.searchKeyword)
        )
      }
    },
    handleAdd() {
      this.dialogTitle = '添加专业'
      this.isEdit = false
      this.form = {
        categoryType: '',
        categoryName: '',
        collegeName: '',
        majorName: '',
        planCount: 0,
        tuitionFee: 0
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
      })
    },
    handleEdit(row) {
      this.dialogTitle = '编辑专业'
      this.isEdit = true
      this.form = { ...row }
      this.dialogVisible = true
    },
    handleSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            if (this.isEdit) {
              await majorApi.update(this.form)
              this.$message.success('更新成功')
            } else {
              await majorApi.add(this.form)
              this.$message.success('添加成功')
            }
            this.dialogVisible = false
            this.loadData()
          } catch (error) {
            this.$message.error('操作失败')
          }
        }
      })
    },
    handleDelete(row) {
      this.$confirm('确定删除该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await majorApi.delete(row.id)
          this.$message.success('删除成功')
          this.loadData()
        } catch (error) {
          this.$message.error('删除失败')
        }
      })
    }
  }
}
</script>

<style scoped>
.major-manage {
  padding: 20px;
}
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.title {
  font-size: 18px;
  font-weight: bold;
}
</style>
